import { useCart } from "@shopify/hydrogen";
import compact from "lodash/compact";
import { useRouter } from "next/router";
import { useEffect } from "react";

export function CartAttribution() {
  const router = useRouter();

  const { cartAttributesUpdate, attributes } = useCart();

  const lookbookId = router.query?.slug?.[0];
  const { message_id: messageId } = router.query;

  useEffect(() => {
    if (typeof lookbookId === "string") {
      const attributesToAdd = compact([
        { key: "lookbookId", value: lookbookId },
        typeof messageId === "string" && messageId.length
          ? { key: "messageId", value: messageId }
          : null,
      ]);

      if (
        !attributesToAdd.every((attributeToAdd) =>
          attributes.some(
            (existingAttribute) =>
              existingAttribute.key === attributeToAdd.key &&
              existingAttribute.value === attributeToAdd.value,
          ),
        )
      ) {
        cartAttributesUpdate(attributesToAdd);
      }
    }
  }, [cartAttributesUpdate, attributes, messageId, lookbookId]);

  return null;
}
